import {
  isDiscontinued as isProductOptionDiscontinued,
  isProductOptionInStock,
} from "@faire/deprecated-retailer-visitor-shared/lib/productOptions";
import {
  areRequiredProductCustomizationsApplied,
  areAppliedProductCustomizationsValid,
} from "@faire/deprecated-retailer-visitor-shared/services/ProductCustomization";
import { ProductAddToCartState } from "@faire/deprecated-retailer-visitor-shared/views/product/cart/useProductAddToCartState";
import { IProductPageResponse } from "@faire/web-api--source/indigofair/data/IProductPageResponse";

import { isSelectedProductDifferentThanCart } from "./isSelectedProductDifferentThanCart";

export const isAddToCartDisabled = (
  product: IProductPageResponse.IPdpProduct,
  productAddToCartState: ProductAddToCartState,
  isBrandActive: boolean | undefined,
  isInvoice: boolean | undefined,
  canAddToCart: boolean
) => {
  const {
    selectedOption,
    selectedQuantity,
    customizations,
    updateQuantityOnChange,
    perStyleOptionVariations,
    exceedMaxAvailableUnits,
  } = productAddToCartState;

  const canAdd = isInvoice || canAddToCart;

  const enableEditProductQuantity = updateQuantityOnChange
    ? isSelectedProductDifferentThanCart(productAddToCartState)
    : selectedQuantity !== 0 && !exceedMaxAvailableUnits;

  if (selectedOption === undefined) {
    return true;
  }

  return (
    // Don't include brand since we handle online only restricted elsewhere
    !canAdd ||
    !isBrandActive ||
    isProductOptionDiscontinued(product, selectedOption) ||
    !enableEditProductQuantity ||
    !isProductOptionInStock(selectedOption, perStyleOptionVariations) ||
    !areRequiredProductCustomizationsApplied(
      product.purchase_information?.customizations || [],
      customizations
    ) ||
    !areAppliedProductCustomizationsValid(
      productAddToCartState.customizationsInMoqCalculation,
      customizations
    )
  );
};
